module.exports = __webpack_public_path__ + "img/54.ed3c3286.svg";